import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
/*
 * Copyright (c) 2024 LS ELECTRIC Co. Ltd. All Reserved.
 */
/*******************************************************************
 * @author HyeongJin O
 * @contact hjoh@detech.co.kr
 * @date 2024-03-15
 * @brief SEI 커뮤니티 사용자 메일 인증
 *
 ********************************************************************/
import { useEffect, useState } from "react";
import { useAsync } from "react-async";
import { useRecoilValue } from "recoil";
// design
import "/static/css/login.css";
// recoil
import { getApiLangState } from "../../../../recoil/langState";
// utils
import * as HttpUtil from "../../../../utils/api/HttpUtil";
import * as CONST from "../../../../utils/Const";
import { useLocation } from "react-router-dom";
import NoCmmCertification from "./NoCmmCertification";
import OkCmmCertification from "./OkCmmCertification";
export default function CmmCertification() {
    // recoil
    const apiLang = useRecoilValue(getApiLangState);
    const location = useLocation();
    const params = new URLSearchParams(location.search);
    const [ok, setOk] = useState("");
    let email = params.get(CONST.STR_EMAIL);
    let key = params.get(CONST.STR_KEY);
    const { data: data, run } = useAsync({
        promiseFn: HttpUtil.PromiseHttp,
        httpMethod: "POST",
        appPath: "/auth/key/valid",
        appQuery: {
            userId: email,
            token: key,
            language: apiLang,
        },
    });
    useEffect(() => {
        if (data) {
            if (data.codeNum == CONST.API_200) {
                setOk("ok");
            }
            else {
                localStorage.setItem(CONST.STR_EMAIL, email);
                setOk("no");
            }
        }
    }, [data]);
    return (_jsx(_Fragment, { children: _jsx("main", Object.assign({ className: "container" }, { children: _jsx("div", Object.assign({ className: "webmailok" }, { children: _jsx("div", Object.assign({ className: "login__form" }, { children: _jsx("form", Object.assign({ action: "#", method: "", name: "loginform" }, { children: ok == "" ? (_jsxs("fieldset", { children: [_jsx("p", Object.assign({ className: "login__info" }, { children: "\uC778\uC99D \uC911\uC785\uB2C8\uB2E4." })), _jsx("button", Object.assign({ type: "button", className: "btn-login" }, { children: _jsx("span", { children: "\uB85C\uADF8\uC778\uD558\uAE30" }) }))] })) : ok == "ok" ? (_jsx(OkCmmCertification, {})) : (_jsx(NoCmmCertification, {})) })) })) })) })) }));
}
